import React, { Component } from "react";
import { sortBy, differenceWith, isEqual } from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import {
  todayDate,
  startDate,
  moveIntoErrorPosition
} from ".././../../../../../utils/commonUtil";
import AmountRecommendGrantAllocation from "../../Components/AmountRecommendGrantAllocation/AmountRecommendGrantAllocation";
import ErrorPopup from "../../../../../../CommonComponents/ErrorPopup/ErrorPopup";
import { SectionContent } from "../../../../../../CommonComponents/commonStyles";
import FlowFooter from "../../../RecommendGrant/Component/FlowFooter/FlowFooter";
import { GrantsDivider } from "../../styles";
import GrantPayment from "../../Components/GrantPayment/GrantPayment";
import { validation } from "../../validation";
import GrantAllocationTable from "../../../RecommendGrant/Component/GrantAllocationTable/GrantAllocationTable";
import GrantAllocation from "../../../RecommendGrant/Component/GrantAllocation/GrantAllocation";
import GrantAllocationNote from "./GrantAllocationNote";
import {
  setFundPoolUpdatedData,
  getPoolsAllocation,
  newAgreement
} from "../../actions";
import regexMap from "../../../../../../utils/regexMap";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import {
  AlertContent,
  Types
} from "../../../../../../CommonComponents/ContentMessages";
import { AlertWrap } from "../../styles";
import { allocationScheduleDerivedStates } from '../../Selectors/AllocationScheduleSelectors';

export class GrantAllocationAndSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allocationPref:
        this.props.grantAllocationDropDown || "weightedAllocations",
      amountPopup: false,
      amount: this.props.amount || "",
      errorMessages: {},
      payment: (this.props.payment.length &&
        JSON.parse(JSON.stringify(this.props.payment))) || [
        {
          grantAmountStr: "",
          intendedPaymentDate: "",
          reportRequirement: false,
          requirementType: null,
          grantRequirementDueDate: null,
          isContingent: false
        }
      ],
      grantAllocationTableFlag: false,
      fundPool: [],
      individualValidator: false,
      amountValidatorContent: "Please enter grant amount",
      weightedAllocEdit: false
    };
    this.popUpContents = {
      amount:
        "Please note that the minimum recommended amount for requesting a grant agreement is $25,000",
      Exceeded:
        "The amount of all payments combined cannot exceed the total grant amount. Please adjust payments to match the grant total.",
      shouldEqual:
        "The amount of payments entered is less than the total grant amount. Please adjust payments to match the grant totalsadasd."
    };
  }

  componentDidMount() {
    this.props.getPoolsAllocation({
      method: "GET",
      url: `/donor-portal/api/investment/${
        this.props.accountId
      }/findInvestmentPoolsForGrantSubmitByAccountIdStartDateAndEndDate?startDateStr=${startDate(
        7
      )}&endDateStr=${todayDate()}`,
      page: "recommendGrant"
    });
    window.scrollTo(0, 0);
  }

  formEqual = () => {
    const stateVal = {
      allocationPref: this.state.allocationPref,
      amount: this.state.amount,
    }

    const propsVal = {
      allocationPref: this.props.grantAllocationDropDown,
      amount: this.props.amount,
    }
    
    const stateAllocation = this.state.fundPool.map(item=>({
      id: item.id,
      name: item.name,
      grantPercentage: item.grantPercentage,
      grantAmount: item.grantAmount
    }));

    const stateAlloc = sortBy(stateAllocation, "id");
    const propAlloc = sortBy(this.createAllocations(this.props.fundPool), "id");

    let allocEqual = false;
    let paymentEqual = false;

    allocEqual = isEqual(stateAlloc,propAlloc);
    paymentEqual = isEqual(this.state.payment, this.props.payment);

    return !(isEqual(stateVal, propsVal) && allocEqual && paymentEqual);
  }

  addPayment = () => {
    let tempArr = [...this.state.payment];
    tempArr.push({
      grantAmountStr: "",
      grantAmountStrErr: false,
      paymentMessage: "",
      intendedPaymentDate: "",
      intendedPaymentDateErr: false,
      reportRequirement: false,
      requirementType: null,
      grantRequirementDueDate: null,
      grantRequirementDueDateErr: false,
      isContingent: false
    });
    this.setState({ payment: [...tempArr] });
    setTimeout(() => {
      const paymentCount = document.getElementsByClassName(
        "grant-agreement-payment"
      ).length;
      moveIntoErrorPosition(`.gaw-payment-${paymentCount}`);
    });
  };

  isEnabled = () => {
    const { amount, allocationPref, fundPool } = this.state;

    return (
      this.grantAmountErrorCheck(amount) &&
      this.paymentCheck() &&
      this.allocationCalculator(fundPool, allocationPref, amount) &&
      this.remainingAmountFinder() === 0
    );
  };

  onAllocationChange = ({ allocations, allocType,grantAmountOrPercentFieldChange }) => {
    this.setState(prevState => ({
      fundPool: [...allocations],
      allocationPref: this.mapAllocationPref(
        prevState.allocationPref,
        allocType,
        grantAmountOrPercentFieldChange
      ),
      weightedAllocEdit: grantAmountOrPercentFieldChange || false
    }));
  };

  handleAllocationPrefChange = preference => {
    this.setState({
      allocationPref: this.mapAllocationPref(preference),
      weightedAllocEdit: false,
      allocPrefState: false
    });
  };

  paymentCheck = () => {
    let paymentChecker = this.state.payment.map(payment => {
      return (
        !payment.grantAmountStrErr &&
        !!payment.intendedPaymentDate &&
        (payment.reportRequirement ? !!payment.grantRequirementDueDate : true)
      );
    });
    return !paymentChecker.includes(false);
  };

  mapAllocationPref = (allocationPref, allocType = "byDollars",grantAmountOrPercentFieldChange=false) => {
    if(grantAmountOrPercentFieldChange) return "byDollars"
    if (allocationPref === "weightedAllocations") return "weightedAllocations";
    return allocType;
  };

  reverseMapAllocationPref = (allocType = "weightedAllocations") => {
    if (allocType !== "weightedAllocations") {
      return "perDollarAmount";
    }
    return allocType;
  };

  errorUpdate = ({ status, key }) => {
    if (status) {
      this.setState(prevState => ({
        errorMessages: {
          ...prevState.errorMessages,
          [key]: status
        }
      }));
    } else {
      this.setState(prevState => ({
        errorMessages: {
          ...prevState.errorMessages,
          [key]: null
        }
      }));
    }
  };

  alternateCheck = (key, index) => {
    const { grantAmountStr, intendedPaymentDate } = this.state.payment[index];
    switch (key) {
      case "grantAmountStr":
        return !!intendedPaymentDate;
      case "intendedPaymentDate":
        return !!parseInt(grantAmountStr);
      default:
        return true;
    }
  };

  paymentChange = (index, event) => {
    const { name, value } = event.target;
    if (regexMap.twoDecimal.test(value)) {
      let tempPayment = this.paymentHandler({ index, key: name, value });
      this.setState({ payment: [...tempPayment] });
    }
  };

  dateChange = (index, key, momentValue) => {
    const tempDate = momentValue
      ? moment(momentValue).format("MM/DD/YYYY")
      : "";
    const upcomingIndex = index + 1;
    const tempPayment = this.paymentHandler({ index, key, value: tempDate });
    const paymentLength = this.state.payment.length;
    this.setState({ payment: [...tempPayment] });
    this.grantTermDates();
    this.setState(prevState => {
      let dueDate = "";
      let newPay = prevState.payment.map((pay, i) => {
        if (i == index) {
          if (key == "intendedPaymentDate") {
            return {
              ...pay,
              intendedPaymentDateErr: !pay.intendedPaymentDate
            };
          } else {
            return {
              ...pay,
              grantRequirementDueDateErr: !pay.grantRequirementDueDate
            };
          }
        } else return pay;
      });

      if (newPay[index].isContingent && key === "grantRequirementDueDate") {
        newPay.forEach((pay, i) => {
          if (dueDate) {
            moment(pay.grantRequirementDueDate).isSameOrBefore(dueDate) &&
              (pay.grantRequirementDueDate = null);
            moment(pay.intendedPaymentDate).isSameOrBefore(dueDate) &&
              (pay.intendedPaymentDate = "");
          }
          if (
            newPay[index].isContingent &&
            index === i &&
            pay.grantRequirementDueDate
          )
            dueDate = pay.grantRequirementDueDate;
        });
      }

      if (
        tempDate &&
        newPay[index].reportRequirement &&
        newPay[index].grantRequirementDueDate &&
        key == "intendedPaymentDate"
      ) {
        newPay.forEach((pay, i) => {
          if (
            i === index &&
            moment(tempDate).isSameOrAfter(pay.grantRequirementDueDate)
          ) {
            pay.grantRequirementDueDate = null;
          }
        });
      }

      if (
        tempDate &&
        index < paymentLength - 1 &&
        key == "intendedPaymentDate"
      ) {
        if (
          newPay[upcomingIndex].intendedPaymentDate &&
          moment(newPay[upcomingIndex].intendedPaymentDate).isSameOrBefore(
            tempDate
          )
        )
          newPay.forEach((pay, i) => {
            if (i > index) {
              pay.intendedPaymentDate = "";
              pay.grantRequirementDueDate = null;
            }
          });
      }
      return { payment: newPay };
    });
  };

  radioChange = (index, e) => {
    let dataIdentifier = e.target['data-tid'];
    let value = e.target.value;
    let key = dataIdentifier || e.target.name;
    let tempPayment;
    if (key === "reportRequirement")
      this.requirementHandle({ index, required: value === "Yes" });
    if (value === "No") {
      tempPayment = this.paymentHandler({ index, key, value: false });
    } else {
      if (key === "isContingent")
        tempPayment = this.contingentCheck(value, key, index);
      else tempPayment = this.paymentHandler({ index, key, value: true });
    }
    if (value === "No" && key === "reportRequirement") {
      tempPayment.forEach((pay, i) => {
        if (i == index) {
          pay.grantRequirementDueDateErr = false;
        }
      });
    }
    this.setState({ payment: [...tempPayment] });
  };

  contingentCheck = (value, key, index) => {
    let tempPay = this.paymentHandler({ index, key, value: true });
    let dueDate = "";
    if (value === "Yes") {
      tempPay.forEach((pay, i) => {
        if (dueDate) {
          moment(pay.grantRequirementDueDate).isSameOrBefore(dueDate) &&
            (pay.grantRequirementDueDate = null);
          moment(pay.intendedPaymentDate).isSameOrBefore(dueDate) &&
            (pay.intendedPaymentDate = "");
        }
        if (value === "Yes" && index === i && pay.grantRequirementDueDate)
          dueDate = pay.grantRequirementDueDate;
      });
    }
    return tempPay;
  };

  requirementHandle = ({ index, required }) => {
    // TODO: Refactor required.
    if (required) {
      let key = "requirementType";
      if (this.props.purposeDescription === "Unrestricted Gift") {
        this.paymentHandler({ index, key, value: "Annual report" });
        this.paymentHandler({ index, key: "isContingent", value: false });
      } else {
        this.paymentHandler({
          index,
          key,
          value: "Narrative and Project budget"
        });
        this.paymentHandler({ index, key: "isContingent", value: false });
      }
    } else {
      let tempPayment = this.state.payment.map((pay, i) => {
        if (i == index) {
          pay["grantRequirementDueDate"] = null;
          pay["isContingent"] = false;
          pay["requirementType"] = null;
        }
        return pay;
      });
      this.setState({ payment: [...tempPayment] });
    }
  };

  paymentHandler = ({ index, key, value }) =>
    this.state.payment.map((pay, i) => {
      if (i == index) pay[key] = value;
      return pay;
    });

  blurHandler = e => {
    let val = e.target.value;
    let key = e.target.name;
    let status = validation(key, val, this.state);
    this.errorUpdate({ status, key });
  };

  paymentBlur = (e, i) => {
    this.setState(prevState => {
      const newPay = prevState.payment.map((pay, index) => {
        if (i == index) {
          return {
            ...pay,
            grantAmountStrErr:
              !pay.grantAmountStr || !(pay.grantAmountStr >= 500),
            paymentMessage: pay.grantAmountStr
              ? "Enter a minimum of $500."
              : "Please enter payment amount."
          };
        } else {
          return pay;
        }
      });
      return { payment: newPay };
    });
  };

  remainingAmountFinder = () => {
    let totalGrantAmount = this.state.payment.reduce(function(a, b) {
      if (b.grantAmountStr !== "") return a + parseFloat(b.grantAmountStr);
      return a;
    }, 0);
    const remainder =
      this.state.amount && +this.state.amount - totalGrantAmount;
    return remainder;
  };

  amountChangeHandler = event => {
    let amount = event.target.value;
    let availableBalance = this.props.availableBalance;
    let key = event.target.name;
    if (regexMap.twoDecimal.test(amount) && amount <= availableBalance) {
      this.setState({
        [key]: amount,
        allocationPref:"weightedAllocations"
      });
    }
  };

  grantAmountPopUpHandler = event => {
    let tempAmount = event.target.value;
    if (tempAmount !== "" && +tempAmount >= 500 && +tempAmount < 25000) {
      this.setState({ amountPopup: true, alertContent: "amount" });
      this.grantAmountError(tempAmount);
    } else if (tempAmount == "") this.grantAmountError(tempAmount);
    else this.grantAmountError(tempAmount);
  };

  grantAmountError = amount => {
    if (amount == "")
      this.setState({
        amountValidatorContent: "Please enter grant amount",
        individualValidator: true
      });
    else if (amount < 500)
      this.setState({
        individualValidator: true,
        amountValidatorContent: "Enter a minimum of $500."
      });
    else if (amount > this.props.availableBalance * 0.75) {
      this.setState({
        individualValidator: true,
        amountValidatorContent:
          "You have exceeded the maximum amount allowed for a grant agreement. Please update the dollar amount so it is below 75% of the available balance."
      });
    } else this.setState({ individualValidator: false });
  };

  grantAmountErrorCheck = amount => {
    return (
      !(amount == "") &&
      !(amount > this.props.availableBalance * 0.75) &&
      !(amount < 500)
    );
  };

  paymentErrorHandler = () => {
    this.setState(prevState => {
      const newPay = prevState.payment.map((pay, i) => ({
        ...pay,
        grantAmountStrErr: !pay.grantAmountStr || !(pay.grantAmountStr >= 500),
        paymentMessage: pay.grantAmountStr
          ? "Enter a minimum of $500."
          : "Please enter payment amount.",
        intendedPaymentDateErr: !pay.intendedPaymentDate,
        grantRequirementDueDateErr: pay.reportRequirement
          ? pay.grantRequirementDueDate
            ? false
            : true
          : false
      }));
      return { payment: newPay };
    });
  };

  grantTermDates = () => {
    const paymentLength = this.state.payment.length;
    const allDates = [];
    const maxDate = () => {
      this.state.payment.forEach(pay => {
        if (pay.intendedPaymentDate)
          allDates.push(moment(pay.intendedPaymentDate));
        if (pay.grantRequirementDueDate)
          allDates.push(moment(pay.grantRequirementDueDate));
      });
      return moment.max(allDates);
    };
    return {
      startDate: paymentLength && this.state.payment[0].intendedPaymentDate,
      endDate: maxDate()
    };
  };

  allocationCalculator = (allocations, allocationPref, grantAmount) => {
    // if allocation pref is by amount check if amount is equal
    if (allocationPref === "byDollars") {
      const totalAmount = allocations.reduce(
        (a, b) => a + parseFloat(b.grantAmount),
        0
      );
      return parseFloat(totalAmount.toFixed(2)) === parseFloat(grantAmount);
    }
    const totalPercent = allocations.reduce(
      (a, b) => a + parseFloat(b.grantPercentage),
      0
    );
    // if allocation preference equals weighted allocation, then check percent for approx
    if (allocationPref === "weightedAllocations") {
      const approxPercent =
        totalPercent > 100 ? Math.floor(totalPercent) : Math.ceil(totalPercent);
      return approxPercent === 100;
    }
    // else check actual
    return totalPercent === 100;
  };

  handleNext = () => {
    const { amount, allocationPref, fundPool } = this.state;
    this.grantAmountError(amount);
    this.paymentErrorHandler();

    if (this.isEnabled()) {
      this.submit();
      this.props.history.push("/grants/grant-agreement/review");
    } else {
      if (!this.grantAmountErrorCheck(amount))
        setTimeout(() => {
          moveIntoErrorPosition(".error-fields");
        });
      else if (!this.allocationCalculator(fundPool, allocationPref, amount)) {
        this.setState({
          showPercentageExceedFlag: true
        });
      } else if (this.remainingAmountFinder() === 0) {
        if (amount > this.props.accountData.availableBalance * 0.75) {
          this.setState({
            showAmountExceededErr: true
          });
        }
      } else if (this.remainingAmountFinder() > 0) {
        this.setState({ amountPopup: true, alertContent: "shouldEqual" });
      } else this.setState({ amountPopup: true, alertContent: "Exceeded" });
    }
  };

  percentExceedCancel = () => {
    this.setState({
      showPercentageExceedFlag: false
    });
    moveIntoErrorPosition("#grant-table");
  };

  amountExceedCancel = () => {
    this.setState({
      showAmountExceededErr: false
    });
    moveIntoErrorPosition("#grant-table");
  };

  amountErrorHandle = () => {
    const { alertContent } = this.state;
    this.setState({ amountPopup: false });
    if (alertContent !== "amount") moveIntoErrorPosition("#gaw-payment");
  };

  paymentFormatter = () => {
    return this.state.payment.map(pay => ({
      grantAmountStr: pay.grantAmountStr,
      intendedPaymentDate: pay.intendedPaymentDate,
      reportRequirement: pay.reportRequirement,
      requirementType: pay.requirementType,
      grantRequirementDueDate: pay.grantRequirementDueDate,
      isContingent: pay.reportRequirement ? pay.isContingent : null
    }));
  };

  errorKeyFinder = () => {
    switch (this.state.alertContent) {
      case "amount":
        return "Low Amount";
      case "Exceeded":
        return "Payment Exceed";
      case "shouldEqual":
        return "Payment Less";
      default:
        return false;
    }
  };

  submit = () => {
    const { amount, allocationPref, fundPool } = this.state;
    const payment = this.paymentFormatter();
    this.props.setFundPoolUpdatedData({
      amount,
      allocationPref,
      payment,
      fundPool
    });
  };

  disableDate = (current, index, key) => {
    const { payment } = this.state;
    if (key === "intendedPaymentDate") {
      if (index != 0 && payment[+index - 1].intendedPaymentDate)
        if (payment[+index - 1].isContingent)
          // Check for contingent condition
          return (
            current &&
            index > 0 &&
            current < moment(payment[+index - 1].grantRequirementDueDate)
          );
        else
          return (
            current &&
            index > 0 &&
            current < moment(payment[+index - 1].intendedPaymentDate)
          );
      else return current && current < moment(todayDate());
    } else {
      return current && current < moment(payment[index].intendedPaymentDate);
    }
  };

  handleBack = () => {
    this.props.history.goBack();
  };

  getStateDataForUpdateChecking = () => {
    const { amount, payment, fundPool, allocationPref } = this.state;
    let fundPoolTemp = [];
    if (fundPool.length) {
      fundPoolTemp = fundPool.map(pool => {
        return {
          amountAllocated:
            allocationPref === "byDollars" ? pool.grantAmount : "",
          amountAllocatedWeighted:
            allocationPref === "weightedAllocations" ? pool.grantAmount : "",
          percentageAllocated:
            allocationPref === "byPercentage" ? pool.grantPercentage : "",
          position: {
            pool: {
              name: pool.name,
              number: "",
              poolId: pool.id.toString()
            }
          },
          weightedPercenatgePerPool: pool.grantAmount.toString()
        };
      });
    }

    return {
      amount,
      payment,
      allocationPref,
      fundPool: fundPoolTemp
    };
  };

  checkForGrantAmount = arr => {
    let obj = arr.filter(val => {
      if (val !== "") {
        return val;
      }
    });
    return obj;
  };

  createAllocations = (fundPool = []) => {
    return fundPool.map(data => ({
      grantAmount: this.checkForGrantAmount([
        data.amountAllocated,
        data.amountAllocatedWeighted,
        data.weightedPercenatgePerPool
      ])[0],
      grantPercentage: (
        (parseFloat(data.weightedPercenatgePerPool) /
          parseFloat(this.state.amount)) *
        100
      ).toFixed(2),
      id: parseInt(data.position.pool.poolId),
      name: data.position.pool.name
    }));
  };

  removePayment = index => {
    const temp = [...this.state.payment];
    const tempPayment = temp.filter((item, i) => {
      if (i !== index) return item;
    });
    this.setState({ payment: [...tempPayment] });
    setTimeout(() => {
      const paymentCount = document.getElementsByClassName(
        "grant-agreement-payment"
      ).length;
      moveIntoErrorPosition(`.gaw-payment-${paymentCount}`);
    });
  };

  handleExit = () => {
    this.props.newAgreement();
    this.props.history.push("/");
  };

  render() {
    let value = parseInt(this.state.amount);
    let isAllocationEnabled = value >= 500;
    const {
      accountData,
      purposeDescription,
      editMode,
      history,
      fundPool,
      poolsAllocation,
      allocationLoading,
      enableCancelPopUp
    } = this.props;
    const {
      allocationPref,
      amount,
      amountPopup,
      payment,
      showPercentageExceedFlag,
      showAmountExceededErr,
      alertContent,
      individualValidator,
      amountValidatorContent,
      weightedAllocEdit
    } = this.state;
    return (
      <div>
        <AmountRecommendGrantAllocation
          amount={amount}
          blurHandler={this.blurHandler}
          amountChangeHandler={this.amountChangeHandler}
          grantAmountPopUpHandler={this.grantAmountPopUpHandler}
          individualValidator={individualValidator}
          amountValidatorContent={amountValidatorContent}
        />
        <GrantsDivider />
        <GrantAllocation
          isEnabled={isAllocationEnabled}
          allocationPref={this.reverseMapAllocationPref(allocationPref)}
          onChange={this.handleAllocationPrefChange}
          grantSectionHeading="Allocation Preferences"
          grantSectionDescription="Please recommend the fund allocation(s) for the grant selected."
          isGa={true}
        >
          {allocationLoading ? (
            <Preloader />
          ) : (
            <GrantAllocationTable
              allocations={this.createAllocations(fundPool)}
              allocationData={poolsAllocation}
              amount={amount}
              allocationPreference={allocationPref}
              availableBalance={accountData.availableBalance}
              scheduleType="oneTime"
              onChange={this.onAllocationChange}
              showAllSharesColumn={false}
              isGrantAgreement={true}
              page={"Grant Agreement"}
              weightedAllocEdit={weightedAllocEdit}
            />
          )}
        </GrantAllocation>
        <GrantAllocationNote />
        <GrantsDivider />
        <GrantPayment
          amount={amount}
          payment={payment}
          addPayment={this.addPayment}
          dateChange={this.dateChange}
          disableDate={this.disableDate}
          blurHandler={this.paymentBlur}
          radioChange={this.radioChange}
          paymentChange={this.paymentChange}
          removePayment={this.removePayment}
          grantTermDates={this.grantTermDates()}
          grantPurposeDropdown={purposeDescription}
          remainingAmountFinder={this.remainingAmountFinder}
        />
        <FlowFooter
          edit={editMode}
          page={"Grant Agreement"}
          enableCancelPopUp={enableCancelPopUp && this.formEqual()}
          keyProperty={"Exit Grant Agreement"}
          keyPropertyUpdate={"Cancel Grant Agreement"}
          handleSecondaryCta={() =>
            history.push("/grants/grant-agreement/charity-purpose")
          }
          handleExitCta={this.handleExit}
          handlePrimaryCta={this.handleNext}
          handleUpdateCancel={this.handleBack}
          handleUpdateCta={this.handleNext}
        />
        <ErrorPopup
          title={
            <AlertContent
              page={"Grant Agreement"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={this.errorKeyFinder()}
              property={"field_header"}
              html={true}
              defaultMessage={"Grant Agreement"}
            />
          }
          show={amountPopup}
          primaryCta={this.amountErrorHandle}
          primaryCtaLabel={
            <AlertContent
              page={"Grant Agreement"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={this.errorKeyFinder()}
              property={"field_alert_button1_text"}
              html={true}
              defaultMessage={"Ok"}
            />
          }
        >
          <AlertWrap>
            <AlertContent
              page={"Grant Agreement"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={this.errorKeyFinder()}
              property={"field_description"}
              html={true}
              defaultMessage={this.popUpContents[alertContent]}
            />
          </AlertWrap>
        </ErrorPopup>
        <ErrorPopup
          title={
            <AlertContent
              page={"Grant Agreement"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Pool Percentage Error"}
              property={"field_header"}
              html={true}
              defaultMessage={"Error"}
            />
          }
          show={showPercentageExceedFlag}
          primaryCta={this.percentExceedCancel}
          primaryCtaLabel={
            <AlertContent
              page={"Grant Agreement"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Pool Percentage Error"}
              property={"field_alert_button1_text"}
              html={true}
              defaultMessage={"Ok"}
            />
          }
        >
          <AlertWrap>
            <AlertContent
              page={"Grant Agreement"}
              type={[Types.PAGE_ALERTS]}
              keyProperty={"Pool Percentage Error"}
              property={"field_description"}
              html={true}
              defaultMessage={"Total grant percentage has to equal 100%"}
            />
          </AlertWrap>
        </ErrorPopup>
      </div>
    );
  }
}

GrantAllocationAndSchedule.propTypes = {
  accountData: PropTypes.object,
  accountId: PropTypes.string,
  allocationLoading: PropTypes.bool,
  amount: PropTypes.string,
  availableBalance: PropTypes.number,
  editMode: PropTypes.bool,
  enableCancelPopUp: PropTypes.bool,
  fundPool: PropTypes.array,
  getPoolsAllocation: PropTypes.func,
  grantAllocationDropDown: PropTypes.string,
  newAgreement: PropTypes.func,
  payment: PropTypes.array,
  poolsAllocation: PropTypes.array,
  purposeDescription: PropTypes.string,
  setFundPoolUpdatedData: PropTypes.func
}

const mapStateToProps = state => ({
  ...allocationScheduleDerivedStates(state.toJS())
});

const mapDispatchToProps = dispatch => ({
  setFundPoolUpdatedData: data => dispatch(setFundPoolUpdatedData(data)),
  getPoolsAllocation: data => dispatch(getPoolsAllocation(data)),
  newAgreement: data => dispatch(newAgreement(data))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GrantAllocationAndSchedule)
);
